import { render } from "./Toolbar.vue?vue&type=template&id=3bfa7468&scoped=true&ts=true"
import script from "./Toolbar.vue?vue&type=script&lang=ts"
export * from "./Toolbar.vue?vue&type=script&lang=ts"

import "./Toolbar.vue?vue&type=style&index=0&id=3bfa7468&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfa7468"]])

export default __exports__